import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import Integrations, { IIntegrationsDispatchProps, IIntegrationsProps } from './Integrations'
import {
  registerAppleHealth,
  registerHealthConnect,
  registerWithoutIntegration,
} from '../RegisterUser/store/RegisterUserActions'
import { getAuthData, getRegisterUserLastUpdate, getUserCompanies } from '../RegisterUser/store/RegisterUserSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any): IIntegrationsProps => ({
  userDto: getAuthData(state),
  lastUpdate: getRegisterUserLastUpdate(state),
  userCompanies: getUserCompanies(state),
  isDuringRegistration: ownProps.isDuringRegistration,
})

const mapDispatchToProps: IIntegrationsDispatchProps = {
  registerAppleHealth,
  registerHealthConnect,
  registerWithoutIntegration,
}

export default connect(mapStateToProps, mapDispatchToProps)(Integrations)
